import { createAsyncThunk } from "@reduxjs/toolkit";
import { enqueueSnackbar } from "notistack";
import {
  resourceProtectThunk,
  ScheduleProtectResources,
} from "./resourceProtectThunk";
import { ResourceFiltersWithAction } from "@/services/cloudchipr.api";
import { generateAutomationFoundResourcesMasterGridId } from "@/components/pages/automations/common/components/found-resources/components/AutomationsFoundResourcesCard";
import { updateGridResourceDataThunk } from "@/store/resources-grid/thunks/data/updateGridResourceDataThunk";

export const automationFoundResourcesProtectionThunk = createAsyncThunk(
  "schedule/automationFoundResourcesProtection",
  async (
    {
      resourcesToProtect,
      resourceFilters,
    }: {
      resourceFilters: ResourceFiltersWithAction[];
      resourcesToProtect: ScheduleProtectResources;
    },
    { dispatch },
  ) => {
    const response = await dispatch(resourceProtectThunk(resourcesToProtect));
    const protect = response?.payload;

    const refetchPromises =
      resourceFilters?.map(({ filter }) => {
        const masterGridId = generateAutomationFoundResourcesMasterGridId(
          filter.type,
        );

        return dispatch(updateGridResourceDataThunk(masterGridId)).unwrap();
      }) ?? [];

    if (protect !== null) {
      enqueueSnackbar(`Protection ${protect ? "enabled" : "disabled"}`, {
        variant: "snackbarAlert",
        AlertSnackBarProps: { severity: "success" },
      });
    }

    await Promise.all(refetchPromises);
  },
);
